module.exports = __webpack_public_path__ + "static/media/success.ba3721e8.png";